import { Component } from '@angular/core';
import { MainPage, NavController, ToastController, ErrorResult, LocalStorageService, AlertController, App, UserService } from '../mainpage';
import { ContestService } from '../../providers/contest';
import { ChampionshipService, Team } from '../../providers/championship';
import { AdminGameGroup, Game } from '../../entities/adminGameGroup';

/*
declare function Teste();
declare var fingerprint;
declare function encryptData(data): any;
declare function decrypt(data): any;
*/

@Component({
  selector: 'page-game',
  templateUrl: 'game.html'
})

export class  GamePage extends MainPage {
    public gameGroups: AdminGameGroup[];
    public selectedGroup: AdminGameGroup;
    public Teams: Team[];

    public currentGame: Game;

    constructor(public navCtrl: NavController, protected toastCtrl: ToastController, public localStorageService: LocalStorageService, public contestService: ContestService
        , public championshipService: ChampionshipService, protected alertController: AlertController,
        protected userService: UserService,
        protected appCtrl: App) {
        super(navCtrl, toastCtrl, localStorageService, alertController, userService, appCtrl);
        this.currentGame = new Game();
        this.loadPage();
    }

    public loadPage(): void {
        this.contestService.GetGames().then((data: AdminGameGroup[]) => {
            this.gamesLoaded(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    /*public doBet(): void {
        this.contestService.DoBet(this.gameGroups).then((data: GameGroup[]) => {
            this.betsPosted(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    public betsPosted(gameGroup: GameGroup[]): void {
        this.presentToast("Aposta realizada com sucesso");
        this.gamesLoaded(gameGroup);
    }*/

    public teamsLoaded(RetTeams: Team[]): void {
        this.Teams = RetTeams;
    }

    public loatTeams(): void {
        this.championshipService.getTeams(this.CurrentChampionship.ChampionshipId).then((data: Team[]) => {
            this.teamsLoaded(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    public gamesLoaded(gameGroup: AdminGameGroup[]): void {
        this.gameGroups = gameGroup;
        for(var i=0; i<this.gameGroups.length; i++) {
            if (this.gameGroups[i].IsDefault) {
                this.selectedGroup = this.gameGroups[i];
                break;
            }
        }
        this.loatTeams();
    }

    public setGoal(game: Game, team: number, event: any): void {
        game.IsChanged = true;
        if (team == 1) {
            game.RealGoalsTeam1 = parseInt(event.srcElement.value);
        }
        else {
            game.RealGoalsTeam2 = parseInt(event.srcElement.value);
        }
    }

    gamesChanged(data: AdminGameGroup[]) {
        this.presentToast("Placares atualizados com sucesso");
        this.gamesLoaded(data);
    }

    public changeGames(): void {
        this.contestService.ChangeGames(this.gameGroups).then((data: AdminGameGroup[]) => {
            this.gamesChanged(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    public setChanged(game: Game): void {
        game.IsChanged = true;
    }

    public compareGroup(g1: AdminGameGroup, g2:AdminGameGroup): boolean {
        return g1.Fullname === g2.Fullname;
    }
}


// WEBPACK FOOTER //
// ./src/pages/contest/game.ts